import React from 'react'
import { Box } from '@mui/material'
import { INTERAX_COLORS } from '../../../constants/colors'
import type { SprintPurposeIcon } from './SprintPurpose.types'

interface SprintPurposeHeaderProps {
  icon: SprintPurposeIcon
  selected: boolean
}

export const SprintPurposeHeader: React.FC<SprintPurposeHeaderProps> = ({ icon: Icon, selected }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: '24px' }}>
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '54px',
        height: '54px',
        borderRadius: '10px',
        backgroundColor: 'rgba(255, 171, 64, 0.2)',
        color: INTERAX_COLORS.sun
      }}
    >
      <Icon className="w-6 h-6" />
    </Box>
    <Box
      sx={{
        width: '24px',
        height: '24px',
        borderRadius: '50%',
        border: `2px solid ${selected ? INTERAX_COLORS.sun : INTERAX_COLORS.thunderGrey}`,
        backgroundColor: selected ? INTERAX_COLORS.sun : 'transparent',
        transition: 'all 0.2s ease-in-out'
      }}
    />
  </Box>
)

export default SprintPurposeHeader
